import { render, staticRenderFns } from "./FccTipoDeficiencia.vue?vue&type=template&id=16f52392"
import script from "./FccTipoDeficiencia.vue?vue&type=script&lang=js"
export * from "./FccTipoDeficiencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports